/**
 * 访问资金管理页面的权限
 */
export const FUND_PAGE_UUID = '332efecd-361e-4e12-ba41-72cf9cd78eae'

/**
 * 管理银行卡账号的权限
 */
export const FUND_MANAGE_BANK_ACTION_UUID =
  '152dec23-57b6-4816-8aed-83376b2bf338'
